import { EditCompositionModal } from "@/components/Composition/EditCompositionModal"
import { getSimUnitData } from "@/services/project/simulation.service"
import { getFlowSimulationSelector } from "@/store/flowsheet/flowsheet.slice"
import { useRequest } from "ahooks"
import { Button } from "antd"
import { useSelector } from "react-redux"

interface CompositionCellEditorProps {
  unitId: string
  attribute: string
  onChange: (val) => void
  value?: number[]
}

export const CompositionCellEditor = (props: CompositionCellEditorProps) => {
  const {unitId, attribute, onChange, value} = props;
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const {data, loading} = useRequest(() => getSimUnitData({sId: flowSimulation?.id, id: unitId}))
  console.log(value)

  if (loading) {
    return null;
  }

  const initValue = (() => {
    const keys = attribute.split(':').filter(item => item !== '')
    const attrData = keys.reduce((res: any, currKey: string) => {
      return res?.[currKey]
    }, data?.vars || {})
    return attrData?.val || []
  })()

  return <EditCompositionModal
    setName={data?.args?.tpps}
    trigger={<Button type="text">Edit Composition</Button>}
    value={value || initValue}
    onChange={(val) => onChange(val)}
  />

}